<template>
    <v-img :src="imageData" :height="height" :width="width" :max-height="maxHeight" :max-width="maxWidth" :min-height="minHeight" :min-width="minWidth" :contain="contain" :aspect-ratio="aspectRatio" :content-class="contentClass"></v-img>
</template>

<script>
export default {
    /**
     * the `imageId` prop is required to load the 'logo' image for a realm
     * the `etag` prop is optional, but can be used to reload an image (e.g. after a new image was uploaded, change the etag to Date.now() in parent component)
     * the other props are passed to v-img
     *
     * NOTE: Vue automatically translates hyphenated names such as "max-width" to camelCase "maxWidth" so when using the component you write :max-width="192" but here we receive it as "maxWidth".
     */
    props: ['alias', 'intent', 'mode', 'etag', 'height', 'width', 'maxHeight', 'maxWidth', 'minHeight', 'minWidth', 'contain', 'aspectRatio', 'contentClass', 'image'],
    // props: {
    //     imageId: {
    //         type: String,
    //         default: null,
    //     },
    //     height: {
    //         type: Number,
    //     },
    //     width:
    // },

    data: () => ({
        content: null,
        contentType: null, // 'image/png'
    }),

    computed: {
        imageData() {
            if (this.contentType && this.content) {
                return `data:${this.contentType};base64,${this.content}`;
            }
            return '';
        },
    },

    watch: {
        etag() {
            this.loadImage();
        },
    },

    methods: {
        async loadImage() {
            try {
                this.$store.commit('loading', { loadBrandImageByIntent: true });
                const response = await this.$client.brandprofile().image.get({ alias: this.alias, intent: this.intent, mode: this.mode });
                if (response) {
                    this.contentType = response.content_type;
                    this.content = response.content_base64;
                }
            } catch (err) {
                console.log('BrandImage.vue loadImage failed', err);
            } finally {
                this.$store.commit('loading', { loadBrandImageByIntent: false });
            }
        },
    },

    mounted() {
        if (this.image) {
            this.contentType = this.image.content_type;
            this.content = this.image.content_base64;
        } else {
            this.loadImage();
        }
    },

};
</script>
